export const CHAT_CONVERSATON_ORG_USED_HEADER = "x-openai-org-id";
export const ASSISTANT_HISTORY_STORAGE_KEY = "ASSISTANT_HISTORY";
export const LOCAL_API_STORAGE_KEY = "OPEN_AI_KEY";
export const CHAT_SETTINGS_STORAGE_KEY = "CHAT_SETTINGS";

export const TASK_NAMES = {
  createPacks: "CREATE_PACKS",
  createSheets: "CREATE_SHEETS",
  createSubsheets: "CREATE_SUBSHEETS",
  addGeneralFields: "ADD_GENERAL_FIELDS",
  addLookupFields: "ADD_LOOKUP_FIELDS",
  addFormulaFields: "ADD_FORMULA_FIELDS",
  sheetsNavigation: "SHEETS_NAVIGATION",
  createDummyData: "CREATE_DUMMY_DATA",
  shareSheet: "SHARE_SHEET",
};

export const FIELDS_ATTRIBUTES_OBJ = {
  0: "is_mandatory",
  1: "is_read_only",
  2: "is_unique",
  3: "is_filter",
  4: "trim_white_spaces",
  5: "allow_free_text",
  6: "is_allow_non_admin",
  //gap
  20: "min_length",
  21: "max_length",
  22: "min_value",
  23: "max_value",
  //gap
  40: "unique_options",
  41: "default_email",
  //gap
  60: "number_format",
  61: "decimals",
  //gap
  80: "currency_type",
  81: "currency_symbol",
  82: "currency_code",
  //gap
  100: "formula",
  101: "formula_column",
  102: "apply_formula",
  //gap
  120: "format",
  //gap
  140: "options",
  141: "colors",
  //gap
  160: "max_files",
  161: "file_permission",
  //gap
  180: "source_list_id",
  181: "source_column_id",
  182: "column_type",
  183: "is_column_updatable",
  184: "query_string",
  185: "is_user_type",
  186: "query",
  187: "is_dynamic",
  188: "query_params",
  //gap
  200: "sub_list_id",
  201: "list_columns",
};

export const FIELD_ATTRIBUTES_BY_FIELD_TYPE = {
  1: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: true, // is_filter
    // 4: true, // trim_white_spaces
    20: 0, // min_length
    21: 100, // max_length
    40: null, // unique_options
  },
  3: {
    0: false, // is_mandatory
    1: false, // is_read_only
    // 3: true, // is_filter
    5: true, // allow_free_text
    6: false, // is_allow_non_admin
    140: [], // options
    141: [], // colors
  },
  4: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: true, // is_filter
    // 4: false, // trim_white_spaces
    120: "M j, Y g:iA", // format
    40: null, // unique_options
  },
  5: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: true, // is_filter
    // 4: true, // trim_white_spaces
    20: 0, // min_length
    21: 100, // max_length
    22: null, // min_value
    23: null, // max_value
    40: null, // unique_options
    60: "100,000,000", // number_format
    61: 2, // decimals
  },
  6: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    3: false, // is_filter
    4: false, // trim_white_spaces
    200: null, // sub_list_id
    201: [], // list_columns
  },
  7: {
    101: null, // formula_column
    102: null, // apply_formula
  },
  8: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: false, // is_filter
    // 4: false, // trim_white_spaces
    40: null, // unique_options
  },
  9: {
    0: false, // is_mandatory
    1: false, // is_read_only
    // 3: false, // is_filter
    160: 20, // max_files
    161: "public", // file_permission
  },
  10: {
    180: null, // source_list_id
    181: null, // source_column_id
    182: "text", // column_type
    183: true, // is_column_updatable
    184: "", // query_string
    // 185: false, // is_user_type
    186: "", // query
    // 187: false, // is_dynamic
    188: [], // query_params
  },
  11: {
    0: false, // is_mandatory
    1: false, // is_read_only
    // 3: false, // is_filter
    // 5: false, // allow_free_text
    140: [], // options
    141: [], // colors
  },
  12: {
    1: false, // is_read_only
    // 3: false // is_filter
  },
  13: {
    0: false, // is_mandatory
    1: false, // is_read_only
    // 3: false, // is_filter
    // 5: false, // allow_free_text
    140: [], // options
    141: [], // colors
  },
  14: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: false, // is_filter
    // 4: false, // trim_white_spaces
    40: null, // unique_options,
    41: false, // default_email
  },
  16: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: false, // is_filter
    // 4: false, // trim_white_spaces
    120: "M j, Y g:iA", // format
  },
  17: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: false, // is_filter
    // 4: false, // trim_white_spaces
    80: "United States Dollar - USD", // currency_type
    81: "$", // currency_symbol
    82: "USD", // currency_code
    60: "100,000,000", // number_format
    61: 2, // decimals
  },
  18: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: false, // is_filter
    // 4: false // trim_white_spaces
  },
  19: {
    // 0: false, // is_mandatory
    // 1: false, // is_read_only
    // 2: false, // is_unique
    // 3: false, // is_filter
    // 4: false, // trim_white_spaces
    100: null, // formula
    101: null, // formula_column
    // 102: null // apply_formula
    // 40: null // unique_options
  },
  20: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: false, // is_filter
    // 4: false, // trim_white_spaces
    // 20: 0, // min_length
    // 21: 100, // max_length
    40: null, // unique_options
  },
  22: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    // 3: false, // is_filter
    // 4: false, // trim_white_spaces
    // 20: 0, // min_length
    // 21: 100, // max_length
    22: null, // min_value
    23: null, // max_value
    60: "10000", // number_format
    61: 4, // decimals
  },
  24: {
    0: false, // is_mandatory
    1: false, // is_read_only
    2: false, // is_unique
    40: null,
  },
};

export const FIELD_TYPES = {
  text: 1,
  dropdown: 3,
  date: 4,
  number: 5,
  subsheet: 6,
  expression: 7,
  multiline: 8,
  file: 9,
  lookup: 10,
  multiselect: 11,
  boolean: 12,
  checklist: 13,
  email: 14,
  datetime: 16,
  currency: 17,
  barcode: 18,
  formula: 19,
  phone: 20,
  percentage: 22,
  url: 24,
};

export const FIELD_TYPES_BY_FIELD_TYPE = {
  1: "text",
  3: "dropdown",
  4: "date",
  5: "number",
  6: "subsheet",
  7: "expression",
  8: "multiline",
  9: "file",
  10: "lookup",
  11: "multiselect",
  12: "boolean",
  13: "checklist",
  14: "email",
  16: "datetime",
  17: "currency",
  18: "barcode",
  19: "formula",
  20: "phone",
  22: "percentage",
  24: "url",
};

export const CODE_STRING = "```";

export const REGEX = {
  name: /^(?=[a-zA-Z0-9_ ]*[a-zA-Z])[a-zA-Z0-9_ ]+$/,
};

export const CHAT_MESSAGE_TAGS = {
  packs: "PACKS",
  currentPack: "CURRENT_PACK_INFO",
  sheetsInCurrentPack: "SHEETS_IN_CURRENT_PACK",
  currentSheetInfo: "CURRENT_SHEET_INFO",
  fieldsInCurrentSheet: "FIELDS_IN_CURRENT_SHEET_INFO",
  firstChatQuery: "FIRST_CHAT_QUERY",
};

export const CHAT_RESPONSE_INITIAL_VALUES = {
  createdAt: null,
  content: "",
  functionCall: {},
  finishReason: "",
  role: "",
};

export const STATUS_COLORS = {
  critical: {
    background: "#da1e28",
    color: "#ffffff",
  },
  serious: {
    background: "#ff832b",
    color: "#000000",
  },
  caution: {
    background: "#f1c21b",
    color: "#000000",
  },
  normal: {
    background: "#24A148",
    color: "#ffffff",
  },
  standby: {
    background: "#0043ce",
    color: "#ffffff",
  },
  off: {
    background: "#6f6f6f",
    color: "#ffffff",
  },
  undefined: {
    background: "#8a3ffc",
    color: "#ffffff",
  },
};

export const OPENAI_MODELS = [
  {
    id: 0,
    name: "gpt-3.5",
  },
  {
    id: 1,
    name: "gpt-4",
  },
];

export const OPENAI_MODEL_VARIANTS = [
  {
    id: 0,
    model: 0,
    name: "gpt-3.5-turbo",
    description: "",
    maxTokens: 4096,
    trainingUpto: "Sep 2021",
  },
  {
    id: 1,
    model: 0,
    name: "gpt-3.5-turbo-16k",
    description: "",
    maxTokens: 16384,
    trainingUpto: "Sep 2021",
  },
  {
    id: 2,
    model: 0,
    name: "gpt-3.5-turbo-0613",
    description: "",
    maxTokens: 4096,
    trainingUpto: "Sep 2021",
    isSnapshot: true,
  },
  {
    id: 3,
    model: 0,
    name: "gpt-3.5-turbo-16k-0613",
    description: "",
    maxTokens: 16384,
    trainingUpto: "Sep 2021",
    isSnapshot: true,
  },
  {
    id: 4,
    model: 0,
    name: "gpt-3.5-turbo-0301",
    description: "",
    maxTokens: 4096,
    trainingUpto: "Jun 2021",
    legacy: true,
  },
  {
    id: 5,
    model: 0,
    name: "text-davinci-003",
    description: "",
    maxTokens: 4097,
    trainingUpto: "Jun 2021",
    legacy: true,
  },
  {
    id: 6,
    model: 0,
    name: "text-davinci-002",
    description: "",
    maxTokens: 4097,
    trainingUpto: "Jun 2021",
    legacy: true,
  },
  {
    id: 7,
    model: 0,
    name: "code-davinci-002",
    description: "",
    maxTokens: 8001,
    trainingUpto: "Jun 2021",
    legacy: true,
  },
  //
  {
    id: 8,
    model: 1,
    name: "gpt-4",
    description: "",
    maxTokens: 8192,
    trainingUpto: "Sep 2021",
  },
  {
    id: 9,
    model: 1,
    name: "gpt-4-0613",
    description: "",
    maxTokens: 8192,
    trainingUpto: "Sep 2021",
    isSnapshot: true,
  },
  // {
  //   id: 10,
  //   model: 1,
  //   name: 'gpt-4-32k',
  //   description: '',
  //   maxTokens: 32768,
  //   trainingUpto: 'Sep 2021',
  // },
  // {
  //   id: 11,
  //   model: 1,
  //   name: 'gpt-4-32k-0613',
  //   description: '',
  //   maxTokens: 32768,
  //   trainingUpto: 'Sep 2021',
  //   isSnapshot: true,
  // },
  {
    id: 12,
    model: 1,
    name: "gpt-4-0314",
    description: "",
    maxTokens: 8192,
    trainingUpto: "Sep 2021",
    legacy: true,
    isSnapshot: true,
  },
  // {
  //   id:13,
  //   model: 1,
  //   name: 'gpt-4-32k-0314',
  //   description: '',
  //   maxTokens: 32768,
  //   trainingUpto: 'Sep 2021',
  //   legacy: true,
  //   isSnapshot: true,
  // },
];
